import { FINANCE_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getSteps: function ({limit = 999, page = 1, sort = 'dateStart&sort[]=-1', projectId}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`]
    if (projectId) query.push(`project[]=${projectId}`)
    if (sort) query.push(`sort[]=${sort}`)
    return instCred.get('steps?' + query.join('&'))
  },
  createStep: function (step) {
    step.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('steps', step)
  },
  updateStep: function (step) {
    step.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('steps/' + step.id, step)
  },
  deleteStep: function (stepId) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.delete('steps/' + stepId)
  }
}



// WEBPACK FOOTER //
// ./src/api/Steps/api.js